import "./src/styles/global.css";
import "@fortawesome/fontawesome-svg-core/styles.css";
// import "@fontsource/poppins/700.css";

import * as React from "react";
import { config } from "@fortawesome/fontawesome-svg-core";
import PageTransition from "./src/components/PageTransition";
import {
  getLinkDomain,
  getLinkType,
  trackEvent,
  trackPageContext,
} from "./src/utils/analytics";

config.autoAddCss = false;

export const wrapPageElement = ({ element, props }) => (
  <PageTransition element={element} location={props.location} />
);

export const onRouteUpdate = ({ location }) => {
  trackPageContext(location?.pathname || "/");
};

export const onClientEntry = () => {
  if (typeof document === "undefined") return;

  document.addEventListener(
    "click",
    (event) => {
      const anchor = event.target?.closest?.("a[href]");
      if (!anchor) return;

      const href = anchor.getAttribute("href") || "";
      const linkType = getLinkType(href);

      if (linkType === "anchor") return;

      trackEvent("link_click", {
        link_text: anchor.textContent,
        link_url: href,
        link_domain: getLinkDomain(href),
        link_type: linkType,
        page_path: window.location?.pathname,
      });
    },
    { capture: true },
  );
};
